import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59')
];

export const server_loads = [];

export const dictionary = {
		"/(app)/(prode)": [12,[2]],
		"/(app)/admin/chat/[id]": [30,[2,5]],
		"/(app)/admin/execution/[id]": [31,[2,5]],
		"/(app)/admin/teams": [32,[2,5]],
		"/(app)/admin/teams/[team_id]": [33,[2,5]],
		"/(app)/admin/users": [34,[2,5]],
		"/(age_verification)/age-verification": [9],
		"/(app)/ai-agent-manager": [35,[2,6]],
		"/(app)/ai-agent-manager/ai-agents": [36,[2,6,7]],
		"/(app)/ai-agent-manager/ai-agents/create": [37,[2,6,7]],
		"/(app)/ai-agent-manager/ai-agents/edit": [38,[2,6,7]],
		"/(app)/(prode)/analytics": [13,[2]],
		"/(app)/(prode)/analytics/[team_id]": [14,[2]],
		"/(app)/api-provider-selection": [39,[2]],
		"/auth": [57],
		"/(app)/billing": [40,[2]],
		"/(app)/(mobile_view)/chats": [10,[2,3]],
		"/(app)/c": [41,[2]],
		"/(app)/c/codebase": [45,[2]],
		"/(app)/c/codebase/[id]": [46,[2]],
		"/(app)/c/codebase/[id]/p/[projectId]": [47,[2]],
		"/(app)/c/codebase/[id]/s/[shareId]": [48,[2]],
		"/(app)/c/[id]": [42,[2]],
		"/(app)/c/[id]/p/[projectId]": [43,[2]],
		"/(app)/c/[id]/s/[shareId]": [44,[2]],
		"/(app)/(prode)/documentation": [15,[2]],
		"/error": [58],
		"/(app)/(prode)/integrations": [16,[2]],
		"/(app)/(prode)/integrations/azure-devops/connect": [19,[2]],
		"/(app)/(prode)/integrations/azure-devops/manage-organizations": [20,[2]],
		"/(app)/(prode)/integrations/github/connect-pat": [21,[2]],
		"/(app)/(prode)/integrations/gitlab/connect-pat": [22,[2]],
		"/(app)/(prode)/integrations/gitlab/manage-groups": [23,[2]],
		"/(app)/(prode)/integrations/slack": [24,[2]],
		"/(app)/(prode)/integrations/slack/connect": [25,[2]],
		"/(app)/(prode)/integrations/[integrationType]/manage-organizations": [17,[2,4]],
		"/(app)/(prode)/integrations/[integrationType]/manage-workspaces": [18,[2,4]],
		"/(app)/manage-team": [49,[2]],
		"/(app)/(prode)/mcp-server": [26,[2]],
		"/(app)/(mobile_view)/my-profile": [11,[2,3]],
		"/(no_access)/no-access": [54],
		"/(app)/oauth/authorize": [50,[2]],
		"/(onboarding)/onboarding/[step]": [55,[8]],
		"/(payment)/payments/[status]": [56],
		"/(app)/(prode)/projects": [27,[2]],
		"/(app)/(prode)/projects/[project_id]": [28,[2]],
		"/(app)/(prode)/repositories": [29,[2]],
		"/(app)/settings": [51,[2]],
		"/(app)/teams/[teamId]/edit": [52,[2]],
		"/(app)/teams/[team_id]/[...path]": [53,[2]],
		"/verification-link-error": [59]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';